import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
}));

export default function Header() {
  const classes = useStyles();
  //   function handleSignout() {
  //     global.auth.signout();
  //   }

  return (
    <div className={classes.root}>
      <AppBar className="app-bar" position="static" title={<img src="" alt="x" />}>
        <Toolbar>
          <img className="logo" src={'opg-logo.png'} alt="logo" />
        </Toolbar>
      </AppBar>
      <center>
        <Typography
          variant="h1"
          className={classes.title}
          style={{ margin: '40px 20px 10px', fontSize: '2rem', fontWeight: '400' }}
        >
          Talent Portfolio Image Uploader
        </Typography>
      </center>
    </div>
  );
}
